import React, { useEffect, useState, useRef } from "react";
import { observer, inject } from "mobx-react";
import { useNavigate } from "react-router-dom";

import TopBarMenu from "../../components/common/TopBarMenu";
import { CalendarComponent } from "../../components/common/CalendarComponent";
import { PrintButton } from "../../components/common/PrintButton";
import EditorComponent from "../../components/common/Editor";
import { ReportComponent } from "../../components/common/ReportComponent";

import { ToplamHastaSayisi } from "../../components/dashboard/ToplamHastaSayisi";
import { BekleyenRezervasyon } from "../../components/dashboard/BekleyenRezervasyon";
import { AylikMuayeneCirosu } from "../../components/dashboard/AylikMuayeneCirosu";
import { TakvimBox } from "../../components/dashboard/TakvimBox";
import { QuestionPicker } from "../../components/dashboard/QuestionPicker";

import {
  getMeetingList,
  upsertMeeting,
  inviteMeeting,
  changeMeetingStatus,
  getRecording,
} from "../../utils/api/Meeting/Dashboard/Meeting";
import {
  getParticipantList,
  getAllParticipantList,
} from "../../utils/api/Meeting/Dashboard/Participant";
import {
  getQuestionList,
  getFormList,
  getFieldList,
  getAllResponses,
} from "../../utils/api/Meeting/Dashboard/Question";
import { formatPhoneNumber } from "../../utils/tools";

import dayjs from "dayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  TextField,
  IconButton,
  Box,
  Container,
  Grid,
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Tooltip,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import { FaPhone, FaRegCopy } from "react-icons/fa";
import {
  HiVideoCamera,
  HiClipboardList,
  HiOutlinePrinter,
  HiSelector,
  HiPlay,
} from "react-icons/hi";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
dayjs.locale("tr");

const MeetingDashboard = ({ store }) => {
  const navigate = useNavigate();
  const reportRef = useRef(null);

  const [meetings, setMeetings] = useState(undefined);
  const [meetingMenu, setMeetingMenu] = useState(false);
  const [totalParticipants, setTotalParticipants] = useState(0);
  const [totalDuration, setTotalDuration] = useState(0);
  const [activeMeetings, setActiveMeetings] = useState([]);
  const [pastMeetings, setPastMeetings] = useState([]);
  const [isReady, setIsReady] = useState(true);
  const [isCalendar, setIsCalendar] = useState(false);

  const [meetingId, setMeetingId] = useState(null);
  const [mobilePhone, setMobilePhone] = useState([]);
  const [selectedForm, setSelectedForm] = useState(null);
  const [meetingName, setMeetingName] = useState("");
  const [meetingDate, setMeetingDate] = useState(dayjs());
  const [duration, setDuration] = useState(60);

  const [questions, setQuestions] = useState([]);
  const [fields, setFields] = useState([]);
  const [forms, setForms] = useState([]);
  const [responses, setResponses] = useState([]);
  const [participantList, setParticipantList] = useState(undefined);
  const [addParticipantMenu, setAddParticipantMenu] = useState(false);
  const [participantsMenu, setParticipantsMenu] = useState(false);
  const [reportDialog, setReportDialog] = useState(null);
  const [participantDialog, setParticipantDialog] = useState(null);
  const [invMeeting, setInvMeeting] = useState(undefined);
  const [openEditor, setOpenEditor] = useState(false);
  const [statusDialog, setStatusDialog] = useState(false);
  const [meetingAudio, setMeetingAudio] = useState("");

  useEffect(() => {
    // Redirect if not logged in
    if (!store.isLogin) {
      store.setLoadingBarStatus(true);
      navigate("/panel/kullanici-girisi");
    } else if (!store.project) {
      store.setMessage("Önce proje seçmelisiniz", true, "warning");
      navigate("/project");
    } else {
      getMeetingListQ();
    }
  }, []);

  // Define meeting statuses
  const meetingStatus = [
    "Bekleniyor",
    "Tamamlandı",
    "Tamamlanmadı",
    "İptal Edildi",
    "Ertelendi",
  ];
  const isSupervisor = store?.trainer?.userType === 51;

  useEffect(() => {
    setTotalParticipants(
      meetings?.reduce((sum, meeting) => sum + meeting.participantCount, 0) ?? 0
    );
    setTotalDuration(
      meetings?.reduce((sum, meeting) => sum + meeting.duration, 0) ?? 0
    );
    const activeMeetingsTemp = [];
    const pastMeetingsTemp = [];
    meetings?.forEach((meeting, idx) => {
      if (
        !meeting.endDate &&
        dayjs(meeting.meetingDate).add(meeting.duration, 'minute').isAfter(dayjs()) &&
        meeting.status === 0
      ) {
        activeMeetingsTemp.push(newTableRow(meeting, idx, true));
      } else {
        pastMeetingsTemp.push(newTableRow(meeting, idx));
      }
    });
    setActiveMeetings(activeMeetingsTemp);
    setPastMeetings(pastMeetingsTemp);
  }, [meetings]);

  const handleCalendar = (isCalendar) => {
    setIsCalendar(isCalendar);
  };

  const handleMeetingMenu = () => {
    setMeetingMenu(!meetingMenu);
    setMobilePhone([]);
    setSelectedForm(null);
    setMeetingName("");
    setMeetingDate(dayjs());
    setDuration(60);
  };

  const handleReport = async () => {
    store.setLoadingBarStatus(false);
    const allParticipantList = await getAllParticipantList(
      store.baseUrl,
      store.token,
      store.trainer.id,
      store.project.projectId
    );
    const getAllResponsesReq = await getAllResponses(
      store.baseUrl,
      store.token
    );
    if (getAllResponsesReq !== null && getAllResponsesReq?.status === 200) {
      setResponses(getAllResponsesReq.data.data);
      setParticipantList(allParticipantList?.data?.data);
      setReportDialog(true);
    }
    store.setLoadingBarStatus(true);
  };

  const handleAddParticipantMenu = (meeting) => {
    if (meeting) {
      const selectedForm = forms.find((f) => f.formId === meeting.formId);
      setAddParticipantMenu(true);
      setMobilePhone([]);
      setSelectedForm(selectedForm);
      setMeetingName("");
      setMeetingId(meeting.meetingId);
    } else {
      setAddParticipantMenu(false);
      setMobilePhone([]);
      setSelectedForm(null);
      setMeetingName("");
      setMeetingId(null);
    }
  };

  const handleInviteDialog = (meeting) => {
    if (meeting) {
      meeting.inviteLink =
        window.location.origin +
        "/meet/" +
        meeting.videoUrl.split("/")[3].split("?")[0];
      setInvMeeting(meeting);
    } else {
      setInvMeeting(undefined);
    }
  };

  const handleMeetingStatus = async () => {
    store.setLoadingBarStatus(false);
    const changeMeetingStatusRes = await changeMeetingStatus(
      store.baseUrl,
      store.token,
      store.trainer.id,
      meetingId,
      statusDialog
    );
    if (
      changeMeetingStatusRes !== null &&
      changeMeetingStatusRes?.status === 200
    ) {
      setStatusDialog(false);
      setMeetingId(null);
      store.setMessage("Durum değiştirildi", true, "success");
      getMeetingListQ();
    } else store.setMessage("Durum değiştirilemedi", true, "error");
    store.setLoadingBarStatus(true);
  };

  const copyInviteLink = (link) => {
    navigator.clipboard.writeText(link);
    store.setMessage("Davet adresi kopyalandı", true, "success");
    handleInviteDialog();
  };

  const addPhoneNumber = () => {
    let newMobilePhone = document.getElementById("mobilePhone").value;
    let name = document.getElementById("name").value;
    if (name === "") {
      store.setMessage("İsim alanı boş olamaz", true, "error");
    } else if (
      mobilePhone.findIndex(
        (r) => Number(r.mobilePhone) === Number(newMobilePhone)
      ) === -1
    ) {
      if (
        Number(newMobilePhone)?.toString().startsWith("5") &&
        Number(newMobilePhone).toString().length === 10
      ) {
        const answ = getAnswers();
        if (answ?.includes(undefined)) {
          return store.setMessage(
            "Zorunlu alan boş bırakılamaz",
            true,
            "error"
          );
        }
        setMobilePhone([
          ...mobilePhone,
          { response: answ, mobilePhone: Number(newMobilePhone), name },
        ]);
        document.getElementById("mobilePhone").value = "";
        document.getElementById("name").value = "";
      } else {
        store.setMessage("Geçersiz numara", true, "error");
      }
    } else {
      store.setMessage("Bu telefon numarası zaten ekli", true, "error");
    }
  };

  const checkPatients = async (meeting) => {
    store.setLoadingBarStatus(false);
    let participantList = undefined;
    if (meeting) {
      participantList = await getParticipantList(
        store.baseUrl,
        store.token,
        store.trainer.id,
        store.project.projectId,
        meeting.meetingId
      );
    } else {
      participantList = await getAllParticipantList(
        store.baseUrl,
        store.token,
        store.trainer.id,
        store.project.projectId
      );
    }
    if (participantList !== null && participantList?.status === 200) {
      if (participantList.data.data.length === 0) {
        store.setMessage("Kayıtlı katılımcı bulunamadı", true, "info");
      } else {
        setParticipantList(participantList.data.data);
        setParticipantDialog(true);
      }
    }
    store.setLoadingBarStatus(true);
  };

  const getAnswers = () => {
    if (selectedForm?.questions)
      return selectedForm?.questions.map((q) => {
        const el = document.getElementById("qpicker-" + q.questionId);
        const field = fields.find((f) => f.fieldId === q.fieldId);
        switch (field.fieldName) {
          case "text":
          case "number":
          case "date":
            if (q?.required && el?.value === "") {
              return undefined;
            }
            return {
              responseValue: el?.value,
              formQuestionId: q?.formQuestionId,
              formId: selectedForm?.formId,
              questionId: q?.questionId,
            };

          case "checkbox":
            const checkboxValue = el?.checked.toString();
            if (q.required && checkboxValue === "false") {
              return undefined;
            }
            return {
              responseValue: checkboxValue,
              formQuestionId: q.formQuestionId,
              formId: selectedForm.formId,
              questionId: q.questionId,
            };

          case "select":
            const selectValue = el.innerHTML.includes("span")
              ? ""
              : el.innerHTML;
            if (q.required && selectValue === "") {
              return undefined;
            }
            return {
              responseValue: selectValue,
              formQuestionId: q.formQuestionId,
              formId: selectedForm.formId,
              questionId: q.questionId,
            };

          default:
            if (q.required && el.value === "") {
              return undefined;
            }
            return {
              responseValue: el.value,
              formQuestionId: q.formQuestionId,
              formId: selectedForm.formId,
              questionId: q.questionId,
            };
        }
      });
  };

  const insertMeeting = async () => {
    if (mobilePhone.length === 0)
      return store.setMessage("Telefon numarası ekleyin", true, "error");
    if (meetingName.trim() === "")
      return store.setMessage("İsim alanı boş olamaz", true, "error");

    const utcDiff = dayjs().utcOffset();
    const meetingDateQ = dayjs(meetingDate).subtract(utcDiff, 'minute').toDate();

    const meet = {
      trainerId: store.trainer.id,
      meetingName,
      responses: mobilePhone,
      meetingDate: meetingDateQ,
      duration,
      formId: selectedForm?.formId,
      projectId: store.project.projectId,
      meetingId: null
    };
    store.setLoadingBarStatus(false);
    let upsertMeetingReq = await upsertMeeting(
      store.baseUrl,
      store.token,
      store.trainer.id,
      meet
    );
    if (upsertMeetingReq !== undefined && upsertMeetingReq !== null) {
      if (upsertMeetingReq.status === 200) {
        store.setMessage("Görüşme işlemi başarılı", true, "success");
        setMeetingMenu(false);
        getMeetingListQ();
      } else {
        store.setMessage("Görüşme işlemi sırasında hata oluştu", true, "error");
      }
    }
    store.setLoadingBarStatus(true);
  };

  const addParticipants = async () => {
    if (mobilePhone.length === 0)
      return store.setMessage("Telefon numarası ekleyin", true, "error");

    const meet = {
      trainerId: store.trainer.id,
      responses: mobilePhone,
      meetingId: meetingId,
      formId: selectedForm?.formId,
    };
    store.setLoadingBarStatus(false);
    let upsertMeetingReq = await upsertMeeting(
      store.baseUrl,
      store.token,
      store.trainer.id,
      meet,
      true
    );
    if (upsertMeetingReq !== undefined && upsertMeetingReq !== null) {
      if (upsertMeetingReq.status === 200) {
        store.setMessage("Ekleme işlemi başarılı", true, "success");
        handleAddParticipantMenu();
        getMeetingListQ();
      } else {
        store.setMessage("Ekleme işlemi sırasında hata oluştu", true, "error");
      }
    }
    store.setLoadingBarStatus(true);
  };

  const inviteNumber = async () => {
    const phone = document.getElementById("invitePhone").value;
    if (
      Number(phone)?.toString().startsWith("5") &&
      Number(phone).toString().length === 10
    ) {
      store.setLoadingBarStatus(false);
      const sendInviteReq = await inviteMeeting(
        store.baseUrl,
        store.token,
        store.trainer.id,
        {
          mobilePhone: phone,
          meetingId: inviteMeeting.meetingId,
        }
      );

      if (sendInviteReq !== undefined && sendInviteReq !== null) {
        if (sendInviteReq.status === 200) {
          store.setMessage("Davet gönderildi", true, "success");
          document.getElementById("invitePhone").value = "";
        } else {
          store.setMessage("Davet sırasında sorun oluştu", true, "error");
        }
      } else store.setMessage("Davet sırasında sorun oluştu", true, "error");
      store.setLoadingBarStatus(true);
    } else {
      store.setMessage("Geçersiz numara", true, "error");
    }
  };

  const getMeetingListQ = async () => {
    store.setLoadingBarStatus(false);
    let getMeetingListReq = await getMeetingList(
      store.baseUrl,
      store.token,
      store.trainer.id,
      store.project.projectId
    );
    if (getMeetingListReq !== undefined && getMeetingListReq !== null) {
      if (getMeetingListReq.status === 200) {
        setMeetings(getMeetingListReq.data.data);
        const formsReq = await getFormList(store.baseUrl, store.token);
        if (formsReq !== undefined && formsReq !== null) {
          if (formsReq.status === 200) {
            setForms(formsReq.data.data);
          }
        }
        const fieldsReq = await getFieldList(store.baseUrl, store.token);
        if (fieldsReq !== undefined && fieldsReq !== null) {
          if (fieldsReq.status === 200) {
            setFields(fieldsReq.data.data);
          }
        }
        const questionsReq = await getQuestionList(store.baseUrl, store.token);
        if (questionsReq !== undefined && questionsReq !== null) {
          if (questionsReq.status === 200) {
            setQuestions(questionsReq.data.data);
          }
        }
      } else if (getMeetingListReq.status === 401) {
        store.setUserLogout();
        window.location.reload();
      }
    }
    store.setLoadingBarStatus(true);
    setIsReady(true);
  };

  const getRecordingAsync = async (meetingid) => {
    store.setLoadingBarStatus(false);
    const getRecordingRes = await getRecording(
      store.baseUrl,
      store.token,
      meetingid
    );
    if (getRecordingRes !== null && getRecordingRes?.status === 200) {
      setMeetingAudio(getRecordingRes.data.data);
    } else {
      store.setMessage("Kayıt bulunamadı", true, "error");
    }
    store.setLoadingBarStatus(true);
  };

  const newTableRow = (meeting, idx, active = false) => (
    <TableRow
      key={idx + (active ? "-a-" : "-p-") + meeting.meetingId}
      sx={{
        "&:last-child td, &:last-child th": { border: 0 },
      }}
      className={meeting.status > 1 ? "meeting-denied" : ""}
    >
      <TableCell component="th" scope="row">
        {meeting.meetingId}
      </TableCell>
      <TableCell component="th" scope="row">
        {meeting.meetingName}
      </TableCell>
      <TableCell component="th" scope="row">
        {meeting.participantCount}
      </TableCell>
      <TableCell component="th" scope="row">
        {dayjs(meeting.startDate ?? meeting.meetingDate).format(
          "DD.MM.YYYY HH:mm"
        )}
      </TableCell>
      <TableCell component="th" scope="row">
        {meeting.duration} dk
      </TableCell>
      {isSupervisor && (
        <TableCell component="th" scope="row">
          {meeting.trainerName}
        </TableCell>
      )}
      <TableCell component="th" scope="row">
        {meetingStatus[meeting.status]}
      </TableCell>
      <TableCell component="th" scope="row" style={{ textAlign: "end" }}>
        {active && (
          <>
            <Tooltip title="Görüşme Odasına Gir">
              <Button
                variant={"contained"}
                onClick={() => navigate("/panel/gorusme/" + meeting.meetingId)}
                style={{ marginInlineEnd: "8px" }}
              >
                <HiVideoCamera
                  style={{
                    fontSize: "20px",
                  }}
                />
              </Button>
            </Tooltip>
            {/* <Tooltip title="Davet Et">
                          <Button variant={"contained"} onClick={() => this.handleInviteDialog(meeting)} style={{ marginInlineEnd: "8px" }}>
                              <FaPhone style={{ fontSize: "20px" }} />
                          </Button>
                      </Tooltip> */}
          </>
        )}
        <Tooltip title="Katılımcı Ekle">
          <Button
            variant={"contained"}
            onClick={() => handleAddParticipantMenu(meeting)}
          >
            <PersonOutlineIcon
              style={{
                fontSize: "20px",
              }}
            />
          </Button>
        </Tooltip>
        <Tooltip title="Katılımcı Listesine Bak">
          <Button
            variant={"contained"}
            style={{
              marginInlineStart: "8px",
            }}
            onClick={() => checkPatients(meeting)}
          >
            <HiClipboardList
              style={{
                fontSize: "20px",
              }}
            />
          </Button>
        </Tooltip>
        <Tooltip title="Durumu Değiştir">
          <Button
            variant={"contained"}
            onClick={() => {
              setStatusDialog(meeting.status.toString());
              setMeetingId(meeting.meetingId);
            }}
            style={{
              marginInlineStart: "8px",
            }}
          >
            <HiSelector
              style={{
                fontSize: "20px",
              }}
            />
          </Button>
        </Tooltip>
        {!active && (
          <Tooltip title="Kaydı Dinle">
            <Button
              variant={"contained"}
              onClick={() => getRecordingAsync(meeting.videoUrl)}
              style={{
                marginInlineStart: "8px",
              }}
            >
              <HiPlay
                style={{
                  fontSize: "20px",
                }}
              />
            </Button>
          </Tooltip>
        )}
      </TableCell>
    </TableRow>
  );

  return (
    <div className="container mps-container">
      <TopBarMenu meeting />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          pt: 9,
        }}
      >
        <Container maxWidth={false}>
          <Grid container spacing={3} sx={{ marginBottom: "12px" }}>
            <Grid item xl={3} lg={3} sm={6} xs={12}>
              <ToplamHastaSayisi
                sx={{ height: "100%" }}
                data={meetings?.length ?? 0}
                text="TOPLAM GÖRÜŞME SAYISI"
              />
            </Grid>
            <Grid item xl={3} lg={3} sm={6} xs={12}>
              <BekleyenRezervasyon
                sx={{ height: "100%" }}
                data={totalParticipants}
                text="TOPLAM KATILIMCI SAYISI"
              />
            </Grid>
            <Grid item xl={3} lg={3} sm={6} xs={12}>
              <AylikMuayeneCirosu
                data={totalDuration}
                usertype={1}
                text="TOPLAM GÖRÜŞME SÜRESİ"
                unit={"dakika"}
              />
            </Grid>
            <Grid item xl={3} lg={3} sm={6} xs={12}>
              <TakvimBox handleiscalendar={handleCalendar} />
            </Grid>
          </Grid>
          <Grid container spacing={3} sx={{ marginBottom: "12px" }}>
            <Grid item xs={12}>
              <Card>
                <CardActions sx={{ flexWrap: "wrap" }}>
                  <Button
                    onClick={() => checkPatients()}
                    variant={"contained"}
                    style={{ margin: "6px" }}
                  >
                    Katılımcı Listesi
                  </Button>
                  <Button
                    onClick={handleMeetingMenu}
                    variant={"contained"}
                    style={{ margin: "6px" }}
                  >
                    Yeni Görüşme Ekle
                  </Button>
                  {isReady && isSupervisor && (
                    <>
                      <Button
                        onClick={handleReport}
                        variant={"contained"}
                        style={{ margin: "6px" }}
                      >
                        Raporlar
                      </Button>
                    </>
                  )}
                </CardActions>
              </Card>
            </Grid>
          </Grid>
          {!isCalendar ? (
            <Grid container spacing={3}>
              <Grid item style={{ height: "100%", width: "100%" }}>
                <Card>
                  <CardHeader
                    title="Aktif Görüşmeleriniz"
                    style={{ paddingBottom: "10px" }}
                  />
                  <CardContent style={{ paddingTop: "0", height: "100%" }}>
                    <TableContainer style={{ marginTop: "0px" }}>
                      <Table sx={{ minWidth: 650 }} aria-label="simple table">
                        <TableHead>
                          <TableRow>
                            <TableCell>ID</TableCell>
                            <TableCell>OTURUM ADI</TableCell>
                            <TableCell>KATILIMCI SAYISI</TableCell>
                            <TableCell>TARİH/SAAT</TableCell>
                            <TableCell>SÜRESİ</TableCell>
                            {isSupervisor && (
                              <TableCell>GÖRÜŞME SAHİBİ</TableCell>
                            )}
                            <TableCell>DURUMU</TableCell>
                            <TableCell style={{ textAlign: "end" }}>
                              İŞLEMLER
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>{activeMeetings}</TableBody>
                      </Table>
                    </TableContainer>
                  </CardContent>
                </Card>
              </Grid>

              {pastMeetings.length > 0 && (
                <Grid item style={{ height: "100%", width: "100%" }}>
                  <Card>
                    <CardHeader
                      title="Geçmiş Görüşmeleriniz"
                      style={{ paddingBottom: "10px" }}
                    />
                    <CardContent style={{ paddingTop: "0", height: "100%" }}>
                      <TableContainer style={{ marginTop: "0px" }}>
                        <Table sx={{ minWidth: 650 }} aria-label="simple table">
                          <TableHead>
                            <TableRow>
                              <TableCell>ID</TableCell>
                              <TableCell>OTURUM ADI</TableCell>
                              <TableCell>KATILIMCI SAYISI</TableCell>
                              <TableCell>TARİH/SAAT</TableCell>
                              <TableCell>SÜRESİ</TableCell>
                              {isSupervisor && (
                                <TableCell>GÖRÜŞME SAHİBİ</TableCell>
                              )}
                              <TableCell>DURUMU</TableCell>
                              <TableCell style={{ textAlign: "end" }}>
                                İŞLEMLER
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>{pastMeetings}</TableBody>
                        </Table>
                      </TableContainer>
                    </CardContent>
                  </Card>
                </Grid>
              )}
            </Grid>
          ) : (
            <Grid container>
              <Card style={{ width: "100%", padding: "18px" }}>
                <CalendarComponent list={meetings} />
              </Card>
            </Grid>
          )}
        </Container>
        <Dialog open={!!meetingMenu} onClose={handleMeetingMenu}>
          <DialogTitle>Yeni Görüşme Oluştur</DialogTitle>
          <DialogContent key={0}>
            <Grid container>
              <Grid item xs={12}>
                <TextField
                  name="name"
                  error={meetingName === ""}
                  value={meetingName}
                  variant="outlined"
                  label="Görüşme Adı"
                  onChange={(e) => setMeetingName(e.target.value)}
                  style={{ width: "100%", marginTop: "15px" }}
                ></TextField>
              </Grid>
              <Grid item xs={6} sx={{ marginTop: "15px" }}>
                <DateTimePicker
                  label="Görüşme Tarihi"
                  disablePast
                  value={meetingDate}
                  onChange={(e) => setMeetingDate(dayjs(e))}
                  renderInput={(params) => <TextField {...params} />}
                  resizable
                  ampm={false}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  name="duration"
                  type="number"
                  value={duration}
                  variant="outlined"
                  label="Süre (Dakika)"
                  onChange={(e) => setDuration(e.target.value)}
                  style={{ width: "100%", marginTop: "15px" }}
                ></TextField>
              </Grid>
              <Grid item xs={12}>
                <FormControl
                  fullWidth
                  style={{ width: "100%", marginTop: "15px" }}
                >
                  <InputLabel>Tema Seçiniz</InputLabel>
                  <Select
                    label="Tema Seçiniz"
                    value={selectedForm}
                    onChange={(e) => {
                      setSelectedForm(e.target.value);
                    }}
                  >
                    {forms?.map((form) => (
                      <MenuItem key={form.formId + "-form"} value={form}>
                        {form.formName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              {selectedForm && (
                <Grid item xs={12}>
                  <Grid item xs={12}>
                    <TextField
                      id="name"
                      name="name"
                      variant="outlined"
                      label="İsim Soyisim*"
                      autoComplete="off"
                      style={{ width: "100%", marginTop: "15px" }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      id="mobilePhone"
                      name="mobilePhone"
                      variant="outlined"
                      label="Telefon Numarası*"
                      autoComplete="off"
                      style={{ width: "100%", marginTop: "15px" }}
                    />
                  </Grid>
                  {selectedForm?.questions.map((fq) => (
                    <Grid item xs={12} key={fq.formQuestionId + "-selected"}>
                      <QuestionPicker
                        question={questions}
                        field={fields}
                        onForm={fq}
                      />
                    </Grid>
                  ))}
                  <Grid item xs={12} sx={{ marginTop: "15px" }}>
                    <Button
                      sx={{ width: "100%", height: "100%" }}
                      onClick={addPhoneNumber}
                      variant="contained"
                    >
                      Kişi Ekle +
                    </Button>
                  </Grid>
                </Grid>
              )}
              {mobilePhone.map((r, idx) => (
                <React.Fragment key={idx + r.phoneNumber}>
                  <Grid item xs={9}>
                    <div
                      style={{ width: "100%", padding: "15px" }}
                      variant="outlined"
                      label="Telefon Numarası"
                    >
                      {r.name +
                        " - " +
                        formatPhoneNumber(r.mobilePhone.toString())}
                    </div>
                  </Grid>
                  <Grid
                    item
                    xs={3}
                    sx={{ marginTop: "15px", paddingInlineStart: "15px" }}
                  >
                    <Button
                      sx={{ width: "100%", height: "100%" }}
                      onClick={() => {
                        const newState = mobilePhone.filter(
                          (ra) => ra.mobilePhone !== r.mobilePhone
                        );
                        setMobilePhone(newState);
                      }}
                      variant="contained"
                      color="error"
                    >
                      Sil -
                    </Button>
                  </Grid>
                </React.Fragment>
              ))}
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleMeetingMenu}>Kapat</Button>
            <Button
              onClick={insertMeeting}
              disabled={!selectedForm}
              variant="contained"
            >
              Oluştur
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={!!addParticipantMenu}
          onClose={() => handleAddParticipantMenu()}
        >
          <DialogTitle>Katılımclı Ekle</DialogTitle>
          <DialogContent key={0}>
            <Grid container minWidth={320}>
              <Grid item xs={12}>
                <Grid item xs={12}>
                  <TextField
                    id="name"
                    name="name"
                    variant="outlined"
                    label="İsim Soyisim*"
                    style={{ width: "100%", marginTop: "15px" }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    id="mobilePhone"
                    name="mobilePhone"
                    variant="outlined"
                    label="Telefon Numarası*"
                    style={{ width: "100%", marginTop: "15px" }}
                  />
                </Grid>
                {selectedForm?.questions.map((fq) => (
                  <Grid item xs={12} key={fq.formQuestionId + "-selected"}>
                    <QuestionPicker
                      question={questions}
                      field={fields}
                      onForm={fq}
                    />
                  </Grid>
                ))}
                <Grid item xs={12} sx={{ marginTop: "15px" }}>
                  <Button
                    sx={{ width: "100%", height: "100%" }}
                    onClick={addPhoneNumber}
                    variant="contained"
                  >
                    Kişi Ekle +
                  </Button>
                </Grid>
              </Grid>
              {mobilePhone.map((r, idx) => (
                <React.Fragment key={idx + r.phoneNumber}>
                  <Grid item xs={9}>
                    <div
                      style={{ width: "100%", padding: "15px" }}
                      variant="outlined"
                      label="Telefon Numarası"
                    >
                      {r.name +
                        " - " +
                        formatPhoneNumber(r.mobilePhone.toString())}
                    </div>
                  </Grid>
                  <Grid
                    item
                    xs={3}
                    sx={{ marginTop: "15px", paddingInlineStart: "15px" }}
                  >
                    <Button
                      sx={{ width: "100%", height: "100%" }}
                      onClick={() => {
                        const newState = mobilePhone.filter(
                          (ra) => ra.mobilePhone !== r.mobilePhone
                        );
                        setMobilePhone(newState);
                      }}
                      variant="contained"
                      color="error"
                    >
                      Sil -
                    </Button>
                  </Grid>
                </React.Fragment>
              ))}
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => handleAddParticipantMenu()}>Kapat</Button>
            <Button
              onClick={addParticipants}
              disabled={mobilePhone.length === 0}
              variant="contained"
            >
              Ekle
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={!!participantsMenu}
          onClose={() => setMeetingMenu(!meetingMenu)}
        >
          <DialogTitle>Görüşme Katılımcıları</DialogTitle>
          <DialogContent key={1}>
            <Grid container>
              <Grid item xs={12}>
                <TextField
                  name="name"
                  error={meetingName === ""}
                  value={meetingName}
                  variant="outlined"
                  label="Görüşme Adı"
                  onChange={(e) => setMeetingName(e.target.value)}
                  style={{ width: "100%", marginTop: "15px" }}
                ></TextField>
              </Grid>
              <Grid item xs={6} sx={{ marginTop: "15px" }}>
                <DateTimePicker
                  label="Görüşme Tarihi"
                  disablePast
                  value={meetingDate}
                  onChange={(e) => setMeetingDate(dayjs(e))}
                  renderInput={(params) => <TextField {...params} />}
                  resizable
                  ampm={false}
                />
              </Grid>
              <Grid item xs={6}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell>ID</TableCell>
                      <TableCell>OTURUM ADI</TableCell>
                      <TableCell>KATILIMCI SAYISI</TableCell>
                      <TableCell>TARİH/SAAT</TableCell>
                      <TableCell>SÜRESİ</TableCell>
                      <TableCell>İŞLEMLER</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>{activeMeetings}</TableBody>
                </Table>
              </Grid>
              <Grid item xs={12}>
                <DialogContentText style={{ padding: "15px" }}>
                  Telefon Numaraları
                </DialogContentText>
              </Grid>
              {mobilePhone.map((resp, idx) => (
                <React.Fragment key={idx + resp.mobilePhone}>
                  <Grid item xs={9}>
                    <div
                      style={{ width: "100%", padding: "15px" }}
                      variant="outlined"
                      label="Telefon Numarası"
                    >
                      {resp.name +
                        "- " +
                        formatPhoneNumber(resp.mobilePhone.toString())}
                    </div>
                  </Grid>
                  <Grid
                    item
                    xs={3}
                    sx={{ marginTop: "15px", paddingInlineStart: "15px" }}
                  >
                    <Button
                      sx={{ width: "100%", height: "100%" }}
                      onClick={() => {
                        setMobilePhone(
                          mobilePhone.filter(
                            (r) => r.mobilePhone !== resp.mobilePhone
                          )
                        );
                      }}
                      variant="contained"
                      color="error"
                    >
                      Sil -
                    </Button>
                  </Grid>
                </React.Fragment>
              ))}
              <Grid item xs={9}>
                <TextField
                  id="mobilePhone"
                  name="mobilePhone"
                  variant="outlined"
                  label="Telefon Numarası"
                  style={{ width: "100%", marginTop: "15px" }}
                ></TextField>
              </Grid>
              <Grid
                item
                xs={3}
                sx={{ marginTop: "15px", paddingInlineStart: "15px" }}
              >
                <Button
                  sx={{ width: "100%", height: "100%" }}
                  onClick={addPhoneNumber}
                  variant="contained"
                >
                  Ekle +
                </Button>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleMeetingMenu}>Kapat</Button>
            <Button onClick={insertMeeting} variant="contained">
              Oluştur
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog open={!!invMeeting} onClose={handleInviteDialog}>
          <DialogTitle id="alert-dialog-title">
            <span style={{ fontWeight: "bold" }}>Davet</span>
            <IconButton
              aria-label="close"
              onClick={() => handleInviteDialog()}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
              }}
            >
              <CloseIcon onClick={handleInviteDialog} />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <Grid container>
              <Grid item xs={12}>
                <span style={{ textAlign: "center" }}>
                  <b>Davet Adresi: </b>
                  {invMeeting?.inviteLink}
                </span>
              </Grid>
              <Grid item xs={12}>
                <Button
                  variant="contained"
                  style={{ width: "100%" }}
                  onClick={() => copyInviteLink(invMeeting?.inviteLink)}
                >
                  Davet Adresini Kopyala
                  <FaRegCopy style={{ marginInlineStart: "5px" }} />
                </Button>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  id="invitePhone"
                  name="invitePhone"
                  variant="outlined"
                  label="Telefon Numarası"
                  style={{ width: "100%", marginTop: "15px" }}
                ></TextField>
              </Grid>
              <Grid item xs={12}>
                <Button
                  variant="contained"
                  style={{ width: "100%", marginTop: "15px" }}
                  onClick={inviteNumber}
                >
                  Davet Gönder
                  <FaPhone style={{ marginInlineStart: "5px" }} />
                </Button>
              </Grid>
            </Grid>
          </DialogContent>
        </Dialog>
        <Dialog
          fullScreen
          open={!!participantDialog}
          onClose={() => setParticipantDialog(false)}
        >
          <DialogTitle id="alert-dialog-title">
            <span style={{ fontWeight: "bold" }}>Kayıtlı Listesi</span>
            <IconButton
              aria-label="close"
              onClose={() => setParticipantDialog(null)}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
              }}
            >
              <CloseIcon onClick={() => setParticipantDialog(false)} />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <Table aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>ID</TableCell>
                  <TableCell>KATILIMCI ADI</TableCell>
                  <TableCell>KAYIT TARİHİ</TableCell>
                  <TableCell>SÜRESİ</TableCell>
                  {/* <TableCell>İŞLEMLER</TableCell> */}
                </TableRow>
              </TableHead>
              <TableBody>
                {participantList?.map((participant, idx) => (
                  <TableRow
                    key={participant.participantId + "-part"}
                    sx={{
                      "&:last-child td, &:last-child th": { border: 0 },
                    }}
                  >
                    <TableCell component="th" scope="row">
                      {participant.participantId}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {participant.name}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {dayjs(participant.createdDate).format(
                        "DD.MM.YYYY HH:mm"
                      )}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {participant.duration} dk
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <PrintButton
              content={
                <Table aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell>ID</TableCell>
                      <TableCell>KATILIMCI ADI</TableCell>
                      <TableCell>KAYIT TARİHİ</TableCell>
                      <TableCell>SÜRESİ</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {participantList?.map((participant, idx) => (
                      <TableRow
                        key={participant.participantId + "-participant"}
                        sx={{
                          "&:last-child td, &:last-child th": {
                            border: 0,
                          },
                        }}
                      >
                        <TableCell component="th" scope="row">
                          {participant.participantId}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {participant.name}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {dayjs(participant.createdDate).format(
                            "DD.MM.YYYY HH:mm"
                          )}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {participant.duration} dk
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              }
            >
              <Button variant="contained">
                Yazdır
                <HiOutlinePrinter
                  style={{
                    marginInlineStart: "5px",
                    fontSize: "20px",
                  }}
                />
              </Button>
            </PrintButton>
          </DialogContent>
        </Dialog>
        <Dialog
          open={!!openEditor}
          fullScreen
          onClose={() => setOpenEditor(false)}
        >
          <DialogTitle id="alert-dialog-title">
            <span style={{ fontWeight: "bold" }}>Editör</span>
            <IconButton
              aria-label="close"
              onClose={() => setOpenEditor(false)}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
              }}
            >
              <CloseIcon onClick={() => setOpenEditor(false)} />
            </IconButton>
            <div style={{ fontWeight: "normal" }}>
              "Yerleştir" menüsünden katılımcı formundaki alanları metin alanına
              ekleyebilirsiniz.
            </div>
          </DialogTitle>
          <DialogContent>
            <EditorComponent />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenEditor(!openEditor)}>Kapat</Button>
            <Button
              onClick={() => setOpenEditor(!openEditor)}
              variant="contained"
            >
              Oluştur
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={!!reportDialog}
          fullScreen
          onClose={() => setReportDialog(false)}
        >
          <DialogTitle id="alert-dialog-title">
            <span style={{ fontWeight: "bold" }}>Raporlar</span>
            <IconButton
              aria-label="close"
              onClose={() => setReportDialog(false)}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
              }}
            >
              <CloseIcon onClick={() => setReportDialog(false)} />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <ReportComponent
              refs={reportRef}
              questions={questions}
              responses={responses}
              participants={participantList}
              meetings={meetings}
              fileName={
                store.trainer?.name +
                " " +
                store.trainer?.surname +
                " Oturum Raporları"
              }
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setReportDialog(false)} variant="contained">
              Kapat
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog open={!!statusDialog} onClose={() => setStatusDialog(false)}>
          <DialogTitle id="alert-dialog-title" sx={{ minWidth: "300px" }}>
            <span style={{ fontWeight: "bold" }}>Durumu Değiştir</span>
            <IconButton
              aria-label="close"
              onClick={() => setStatusDialog(false)}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
              }}
            >
              <CloseIcon onClick={() => setStatusDialog(false)} />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <FormControl fullWidth style={{ width: "100%", marginTop: "15px" }}>
              <InputLabel>Durum Seçiniz</InputLabel>
              <Select
                label="Durum Seçiniz"
                value={statusDialog}
                onChange={(e) => setStatusDialog(e.target.value)}
              >
                {meetingStatus.map((status, idx) => (
                  <MenuItem key={"status-" + idx} value={idx.toString()}>
                    {status}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                setStatusDialog(false);
                setMeetingId(0);
              }}
            >
              Kapat
            </Button>
            <Button onClick={handleMeetingStatus} variant="contained">
              Değiştir
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog open={!!meetingAudio} onClose={() => setMeetingAudio("")}>
          <DialogTitle id="alert-dialog-title" sx={{ minWidth: "300px" }}>
            <span style={{ fontWeight: "bold" }}>Görüşme Kaydı</span>
            <IconButton
              aria-label="close"
              onClick={() => setMeetingAudio("")}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
              }}
            >
              <CloseIcon onClick={() => setMeetingAudio("")} />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <audio controls>
              <source src={meetingAudio} type="video/mp4" />
            </audio>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setMeetingAudio("")}>Kapat</Button>
          </DialogActions>
        </Dialog>
      </Box>
    </div>
  );
};

export default inject("store")(observer(MeetingDashboard));
